import React, { useEffect, useState } from 'react'
import { AcademySelect, Btn, NavBtn, NavLeftArea, TitleWrapper } from '../Navigation/styles'
import { FaBars } from 'react-icons/fa6'
import { useAcademyList } from 'app/gomsacademy/hooks/AcademyList'
import API from 'utils/api'
import { useToken } from 'app/hooks'
import { message, Modal, Upload } from 'antd'
import { useNavigate, useLocation } from 'react-router-dom'
import { useGetMyInfo } from 'app/gomsacademy/hooks/GetMyInfo'
import { STORAGE_URL } from 'app/constants/APIKEYS'
import styled from 'styled-components'

const NavLeft = ({ setOpenSide, menu, setMenu }) => {
	const navigate = useNavigate()
	const { data: token } = useToken()
	const { AcademyListData } = useAcademyList()
	const { myInfo, mutate: myInfoMutate } = useGetMyInfo()
	const location = useLocation()
	const { pathname } = location
	const current = pathname.split('/admin/academy/')[1]
	const academyMenus = ['academy', 'note', 'service']
	const isAcademySection = academyMenus.includes(current || '')

	const handleTitleClick = () => {
		// window.location.reload()
		window.location.href = '/'
	}

	const handleBtnClick = menu => {
		navigate('/admin/academy/' + menu)
		setMenu(menu)
	}

	const [selectValue, setSelectValue] = useState(myInfo?.branchName || '')
	const [selectedOptionWidth, setSelectedOptionWidth] = useState(0)
	const [showLogoModal, setShowLogoModal] = useState(false)
	const [uploading, setUploading] = useState(false)

	// Get current branch info
	const currentBranch = AcademyListData?.find(branch => branch.name === myInfo?.branchName)

	const handleChangeAcademy = e => {
		const branchId = e.target.options[e.target.selectedIndex].getAttribute('data-id')
		setSelectValue(e.target.value)
		API.post('/branch/' + branchId, token + '', {})
			.then((res: any) => {
				if (res.result.success) {
					message.success(e.target.value + '선택')
					myInfoMutate()
				}
			})
			.catch((err: any) => {})
	}

	const handleLogoUpload = async (file: File) => {
		if (!currentBranch?.id) {
			message.error('학원 정보를 찾을 수 없습니다.')
			return false
		}

		const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
		if (!isJpgOrPng) {
			message.error('JPG/PNG 파일만 업로드 가능합니다.')
			return false
		}
		const isLt10M = file.size / 1024 / 1024 < 10
		if (!isLt10M) {
			message.error('이미지는 10MB 이하여야 합니다.')
			return false
		}

		const formData = new FormData()
		formData.append('file', file)

		setUploading(true)
		try {
			const res = await API.postImage('POST', `/branch/${currentBranch.id}/logo`, token + '', formData)
			if (res.result.success) {
				message.success('로고가 업로드되었습니다.')
				window.location.reload()
			} else {
				message.error(res.result.message || '로고 업로드에 실패했습니다.')
			}
		} catch (err) {
			message.error('로고 업로드 중 오류가 발생했습니다.')
		} finally {
			setUploading(false)
		}
		return false
	}

	const handleLogoDelete = async () => {
		if (!currentBranch?.id) {
			message.error('학원 정보를 찾을 수 없습니다.')
			return
		}

		const shouldDelete = window.confirm('정말로 로고를 삭제하시겠습니까?')
		if (!shouldDelete) return

		try {
			const res = await API.delete(`/branch/${currentBranch.id}/logo`, token + '', {})
			if (res.result.success) {
				message.success('로고가 삭제되었습니다.')
				setShowLogoModal(false)
				window.location.reload()
			} else {
				message.error(res.result.message || '로고 삭제에 실패했습니다.')
			}
		} catch (err) {
			message.error('로고 삭제 중 오류가 발생했습니다.')
		}
	}

	useEffect(() => {
		if (selectValue?.length <= 5) {
			setSelectedOptionWidth(80)
		} else if (selectValue?.length >= 6) {
			setSelectedOptionWidth(110)
		}
	}, [selectValue])

	return (
		<NavLeftArea>
			<TitleWrapper>
				<div className="icon" onClick={() => setOpenSide(true)}>
					<FaBars />
				</div>
				{current !== 'academy' ? (
					<div className="title" onClick={handleTitleClick}>
						<h1 className="none">학원생 관리 시스템</h1>
						<BranchInfoWrapper>
							{currentBranch?.logoUrl && (
								<LogoWrapper onClick={(e) => {
									e.stopPropagation()
									if (myInfo?.admin || myInfo?.master) {
										setShowLogoModal(true)
									}
								}}>
									<img src={`${STORAGE_URL}/${currentBranch.logoUrl}`} alt="학원 로고" />
								</LogoWrapper>
							)}
							<p>
								GoMStem <br />
								{myInfo?.branchName}
							</p>
						</BranchInfoWrapper>
					</div>
				) : (
					<>
						<h1 onClick={handleTitleClick}>학원생 관리 시스템</h1>
						<AcademySelect
							style={{ width: selectedOptionWidth }}
							value={selectValue}
							onChange={handleChangeAcademy}>
							<option value="">학원선택</option>
							{AcademyListData?.map(it => (
								<option key={it.id} value={it.name} data-id={it.id}>
									{it.name}
								</option>
							))}
						</AcademySelect>
					</>
				)}
			</TitleWrapper>
			{!isAcademySection ? (
				<NavBtn>
					<Btn onClick={() => handleBtnClick('')} className={menu === '' ? 'selected' : ''}>
						홈
					</Btn>
					{myInfo?.admin ? (
						<>
							<Btn
								onClick={() => handleBtnClick('lecture')}
								className={menu === 'lecture' ? 'selected' : ''}>
								강의관리
							</Btn>
							<Btn
								onClick={() => handleBtnClick('student')}
								className={menu === 'student' ? 'selected' : ''}>
								학생관리
							</Btn>
							<Btn
								onClick={() => handleBtnClick('employee')}
								className={menu === 'employee' ? 'selected' : ''}>
								직원관리
							</Btn>
						</>
					) :
					<>
						<Btn
							onClick={() => handleBtnClick('student')}
							className={menu === 'student' ? 'selected' : ''}>
							학생관리
						</Btn>
					</>
					}
					<Btn
						onClick={() => handleBtnClick('attendance')}
						className={menu === 'attendance' ? 'selected' : ''}>
						출결확인
					</Btn>
					{myInfo?.admin ? (
						<>
							<Btn
								onClick={() => handleBtnClick('payment')}
								className={menu === 'payment' ? 'selected' : ''}>
								결제관리
							</Btn>
						</>
					) : null}
				</NavBtn>
			) : (
				<NavBtn>
					<Btn
						onClick={() => handleBtnClick('academy')}
						className={menu === 'academy' ? 'selected' : ''}>
						학원관리
					</Btn>
					{myInfo?.master ? (
						<Btn
							onClick={() => handleBtnClick('service')}
							className={menu === 'service' ? 'selected' : ''}>
							서비스 관리
						</Btn>
					) : null}
					<Btn onClick={() => handleBtnClick('note')} className={menu === 'note' ? 'selected' : ''}>
						오답노트
					</Btn>
				</NavBtn>
			)}

			{/* Logo Upload Modal */}
			<Modal
				title="학원 로고 관리"
				open={showLogoModal}
				onCancel={() => setShowLogoModal(false)}
				footer={null}
				width={400}
			>
				<ModalContent>
					{currentBranch?.logoUrl ? (
						<CurrentLogoPreview>
							<img src={`${STORAGE_URL}/${currentBranch.logoUrl}`} alt="현재 로고" />
						</CurrentLogoPreview>
					) : (
						<NoLogoPlaceholder>등록된 로고가 없습니다</NoLogoPlaceholder>
					)}
					<ButtonGroup>
						<Upload
							accept="image/jpeg,image/png"
							beforeUpload={handleLogoUpload}
							showUploadList={false}
						>
							<UploadButton disabled={uploading}>
								{uploading ? '업로드 중...' : currentBranch?.logoUrl ? '로고 교체' : '로고 업로드'}
							</UploadButton>
						</Upload>
						{currentBranch?.logoUrl && (
							<DeleteButton onClick={handleLogoDelete}>
								로고 삭제
							</DeleteButton>
						)}
					</ButtonGroup>
					<HelpText>JPG, PNG 파일만 업로드 가능합니다. (최대 10MB)</HelpText>
				</ModalContent>
			</Modal>
		</NavLeftArea>
	)
}

const BranchInfoWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`

const LogoWrapper = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 8px;
	overflow: hidden;
	border: 1px solid #e8e8e8;
	background-color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: all 0.3s;

	&:hover {
		border-color: #1890ff;
		transform: scale(1.05);
	}

	img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
`

const ModalContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: 20px 0;
`

const CurrentLogoPreview = styled.div`
	width: 100%;
	height: 200px;
	border: 2px dashed #d9d9d9;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #fafafa;
	padding: 20px;

	img {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
	}
`

const NoLogoPlaceholder = styled.div`
	width: 100%;
	height: 200px;
	border: 2px dashed #d9d9d9;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #fafafa;
	color: #999;
	font-size: 16px;
`

const ButtonGroup = styled.div`
	display: flex;
	gap: 12px;
	justify-content: center;
`

const UploadButton = styled.button`
	padding: 10px 20px;
	background-color: #1890ff;
	color: #fff;
	border: none;
	border-radius: 6px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 500;
	transition: all 0.3s;

	&:hover {
		background-color: #40a9ff;
	}

	&:disabled {
		background-color: #d9d9d9;
		cursor: not-allowed;
	}
`

const DeleteButton = styled.button`
	padding: 10px 20px;
	background-color: #ff4d4f;
	color: #fff;
	border: none;
	border-radius: 6px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 500;
	transition: all 0.3s;

	&:hover {
		background-color: #ff7875;
	}
`

const HelpText = styled.div`
	text-align: center;
	color: #999;
	font-size: 12px;
`

export default React.memo(NavLeft)
